import { render, staticRenderFns } from "./InputModal.vue?vue&type=template&id=45d0b752&"
import script from "./InputModal.vue?vue&type=script&lang=js&"
export * from "./InputModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports